class HilConnectorByInput {
  private input: Record<string, unknown>;
  private level: number = 1;

  constructor(private $element: ng.IAugmentedJQuery) {}

  $onInit() {
    const aiView = this.$element[0].querySelector('ai-view');
    const elInput = this.$element[0]['input'];
    window['hiReady'](() => {
      if (aiView) {
        aiView['invoke'](elInput);
      }
    });
  }
}

angular.module('capability-ng-scheduler').component('hilConnectorByInput', {
  template: `<ai-view level="{{$ctrl.level}}" id="hil-connector-by-input"></ai-view>`,
  bindings: {
    input: '<',
    level: '<'
  },
  controller: HilConnectorByInput
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/hil/hil_connector_by_input/hil_connector_by_input.ts